import { Group, Object3D, Mesh } from 'three';

export abstract class RenderUtils {
	static clearGroup(group: Group) {
		group.traverse((object) => {
			if (!RenderUtils.isMesh(object)) return;

			if (object.geometry) object.geometry.dispose();
		});

		group.clear();
	}

	static disposeObject(object: Object3D) {
		object.removeFromParent();

		if (RenderUtils.isMesh(object)) object.geometry.dispose();

		object.traverse((object) => {
			if (!RenderUtils.isMesh(object)) return;
			if (object.geometry) object.geometry.dispose();
		});
	}

	static isMesh(object: Object3D): object is Mesh {
		return object instanceof Mesh;
	}
}
